
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function FlashcardsPreview() {
  const benefits = [
    "Create unlimited flashcard decks for any subject",
    "Automatic spaced repetition algorithm for optimal retention",
    "Track your memory strength for each card over time",
    "Import flashcards directly from your quiz mistakes",
    "Collaborate and share flashcards with peers",
    "Multi-format support including text, images, and equations"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/75f6ea41-d106-46c0-9b11-6f179333f0a4.png",
      caption: "Flashcards - Master concepts with spaced repetition"
    },
    {
      url: "/lovable-uploads/dec4bd77-fe47-4402-a470-61c7f7814d13.png",
      caption: "Current Affairs - Stay updated with relevant news"
    }
  ];

  return (
    <FeatureShowcase
      title="Interactive Flashcards"
      description="Master any subject with our advanced spaced repetition flashcard system."
      featureName="Flashcards"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
